import {validators} from 'vue-form-generator';

export const fleetSize = {
                            type: 'dropdown',
                            label: '',
                            id: 'fleet-size',
                            model: 'fleetSize',
                            values: [
                                {name: "1 - 2", value: "1 - 2"},
                                {name: "3 - 10", value: "3 - 10"}
                            ],
                            required: true,
                            disabled: false,
                            styleClasses: "col xs-12 md-3",
                            min: 2,
                            validator: [validators.string],
}